import { render, staticRenderFns } from "./add-prize-num.vue?vue&type=template&id=5af8eb11&scoped=true"
import script from "./add-prize-num.vue?vue&type=script&lang=js"
export * from "./add-prize-num.vue?vue&type=script&lang=js"
import style0 from "./add-prize-num.vue?vue&type=style&index=0&id=5af8eb11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af8eb11",
  null
  
)

export default component.exports